import { message } from 'antd';

export const Success = (msg) => message.success(msg);
export const Error = (msg, duration) => message.error(msg, duration);
export const Warning = (msg) => message.warning(msg);
export const Info = (msg) => message.info(msg);
